import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.shared-accounts.request-center.approvals', {
        url: '/approvals',
        views: {
            '': 'approvals',
        },
        resolve: {approvals},
    })
}

/** @ngInject */
function approvals(RequestCenterService) {
    return RequestCenterService.getApprovals();
}



// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/approvals/approvals.state.js